import {Booking, CompanyLead, DKK, OnDemand, Package} from "./classes";
import {IBookingData, IOnDemandRequestData, IReepayInit} from "./interfaces";

export type TKlippeCardCode = string;
export type IsNextStateActionDoable = boolean;
export type IProduct = Booking | OnDemand | Package | CompanyLead;
export type TMedium = "Online" | "InPerson";
export type Profile_ID = number;
export type Therapist_ID = number;
export type ProblemDescription = string;
export type KlippeCardCode = string;
export type Gender = "Male" | "Female";
export type Time = string;
export type Multiplier = number;
export type OrderPrice = DKK | "COVERED";

export type DiscountType = "BookingDiscount" | "KlippeCardDiscount" | "GiftCardDiscount";

export type BasisType_ID = number;
export type EducationName = string;
export type Goal_ID = number;
export const reepayPaymentMethod = ["sca-card", "mobilepay"] as const;
export type ReepayPaymentMethod = typeof reepayPaymentMethod[number];

export type PriceForProductDetails = IBookingData | IOnDemandRequestData;
export type Reepay_SessionID = string;
export type Reepay_OrderHandle = string;
export type Reepay_SessionURL = string;
export type TWeekDay = "MON" | "TUE" | "WED" | "THU" | "FRI" | "SAT" | "SUN";
export type RequestString = "Request" | "Not Request";
export type PTransportation = "Bil" | "Cykel";
export type BookingId = string;
export type OrderChangesAgent = "resource" | "customer" | "admin";
export type Medium = "InPerson" | "Online";
export type ServiceDate = string;
export type TypeOfPackaging = "Envelope" | "Box" | "Email";
export type ServiceType_ID = number;
export type ServiceTypeName = string;
export type Alias = string;
export type CustomerEmail = string;
export type CustomerFirstName = string;
export type CustomerLastName = string;
export type CustomerPhone = string;

export const checkoutPaymentMethods = ["Mobile Pay", "Card"] as const;
export const checkoutAdminPaymentMethods = ["Mobile Pay", "Card", "Pay Later"] as const;
export type CheckoutPaymentMethod = typeof checkoutPaymentMethods[number];
export type CheckoutAdminPaymentMethod = typeof checkoutAdminPaymentMethods[number];

export const paymentMethods = [
  ...checkoutAdminPaymentMethods,
  ...checkoutPaymentMethods,
  "Mobile Pay Invoice",
  "Gave",
  "Klippe",
  "Kontant",
  "Bank",
  "Other",
  "CreditGave",
  "CreditKlippe",
  "PartlyCreditGave",
  "PartlyCreditKlippe",
  "Mobile Pay Reepay",
];
export type PaymentMethod = typeof paymentMethods[number];

export type TBasisTypeProviders = Map<
  number,
  {
    Profile_ID: number;
    Alias: string;
    Gender: Gender;
    BasisTypes: Map<
      string,
      {
        BasisType_ID: number;
        BasisName: string;
        Medium: string;
      }
    >;
  }
>;
export type NumberOfServiceReviews = number;

export type PostSuccess = "Success";
export type FinalizeResponse = IReepayInit | BookingReepayInit | undefined | {message: string};
export type BookingReepayInit = IReepayInit & {bookingId: BookingId};
export type SubmissionType = "BookingSale" | "GiftCardSale" | "PartnerSignupLead" | "CompanyLead";

export type DeskPricesDTO = {
  serviceTypeId: number;
  serviceTypeName: string;
  defaultPrice: number;
  setPrice: number | undefined;
  isSetByPartner: boolean;
};

export type BookingDataProps = {
  id: BookingId;
  customerName: string;
  status: string;
  partner: string;
  type: string;
  serviceDate: string;
  serviceDuration: number;
  time: string;
  isMotherBooking: boolean;
  address: {
    address: string;
    coordinate: {
      geoLat: string;
      geoLng: string;
    };
    zipCode: string;
    floor: number;
  };
  balance: number;
  customerId: number;
  profileId: number;
  paymentNote: string;
  rrShare: number;
  partnerShare: number;
  originalPrice: number;
  motherBookingId?: BookingId;
  totalPrice: number;
};

export type dawaAddress = {
  address: string;
  coordinate: {
    geoLat: string;
    geoLng: string;
  };
  zipCode: string;
  floor: number;
};

export type DeskBookingsDTO = {
  isActive: boolean;
  id: string;
  serviceDate: string;
  bookingsDate: string;
  originalPrice: number;
  totalPrice: number;
  balance: number;
  partnerShare: number;
  rrShare: number;
  paymentNote: string;
  isMotherBooking: boolean;
  address: dawaAddress;
  service: {
    id: number;
    name: string;
    duration: number;
    goal: {
      id: number;
      name: string;
      basisType: {
        id: number;
        name: string;
      };
    };
  };
  partner: {
    id: number;
    alias: string;
    email: string;
    phone: string;
    address: dawaAddress;
    basisTypes: string[];
    isTest: boolean;
    isActive: boolean;
    isDisplayed: boolean;
  };
  customer: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    customerType: string;
    companyId: number | undefined;
  };
};
